export const config = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? 'http://localhost:3000',
  oidcAuthority: (import.meta.env.VITE_OIDC_AUTHORITY as string | undefined) ?? 'http://localhost:8081/realms/usc',
  oidcClientId: (import.meta.env.VITE_OIDC_CLIENT_ID as string | undefined) ?? 'usc-web',
};
